import React, { useState } from 'react';
import { TreeView } from "views/pages/manage/common/commonComponents/tree";
import { MinusSquare, PlusSquare, EndSquareIcon, StyledTreeItem } from '../../common/commonComponents/treeView';
import { Dialog } from '@mui/material';
import { ReactComponent as CloseIcon } from "assets/img/svg/closeSquare.svg";

const ConcessionCategoryDialog = ({
    categoryData,
    dialogInfo = {},
    setDialogInfo = {},
    rowForm,
    setRowForm
}) => {

    console.log('categoryData', categoryData);
    console.log('rowForm', rowForm);

    const { isOpen, viewOnly } = dialogInfo;

    const [expandedNodes, setExpandedNodes] = useState(() => {
        const { categoryId, subCategoryId, subSubCategoryId } = rowForm;
        return ([
            ...(categoryId ? [`${categoryId}-c`] : []),
            ...(subCategoryId ? [`${subCategoryId}-sc`] : []),
            ...(subSubCategoryId ? [`${subSubCategoryId}-ssc`] : []),
        ])
    })

    const handleToggle = (e, nodeIds) => {
        // console.log('nodeIds',nodeIds)
        setExpandedNodes(nodeIds)
    }

    console.log('expandedNodes', expandedNodes);

    const onCategoryCheckboxClick = (e, category) => {
        const checked = e.target.checked;
        setRowForm(prev => ({
            ...prev,
            categoryId: checked ? category?.id : ""
        }))
    }

    const onSubCategoryCheckboxClick = (e, category, subCategory) => {
        const checked = e.target.checked;
        setRowForm(prev => ({
            ...prev,
            ...(checked
                ? { categoryId: category?.id, subCategoryId: subCategory?.id }
                : { categoryId: "", subCategoryId: "" }
            )
        }))
    }

    const onSubSubCategoryCheckboxClick = (e, category, subCategory, subSubCategory) => {
        const checked = e.target.checked;
        setRowForm(prev => ({
            ...prev,
            ...(checked
                ? { categoryId: category?.id, subCategoryId: subCategory?.id, subSubCategoryId: subSubCategory?.id }
                : { categoryId: "", subCategoryId: "", subSubCategoryId: "" }
            )
        }))
    }

    const closeDialog = () => {
        setDialogInfo({})
        viewOnly && setRowForm({});
    };
    return (

        <Dialog
            open={!!isOpen}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "500px",
                        height: "100%",
                        maxHeight: "500px"
                    },
                },
            }}



        >
            <div className='d-flex flex-column p-3'>

                <div className='d-flex justify-content-between'>
                    <h3>Select Category</h3>
                    <CloseIcon onClick={closeDialog} />
                </div>

                <div className='d-flex justify-content-center'>
                    <TreeView
                        aria-label="icon expansion"
                        defaultCollapseIcon={<MinusSquare />}
                        defaultExpandIcon={<PlusSquare />}
                        defaultEndIcon={<EndSquareIcon />}
                        expanded={expandedNodes}
                        onNodeToggle={handleToggle}
                        sx={{ flexGrow: 1, maxWidth: 400, overflowY: 'auto', fontWeight: 600, paddingRight: '5px' }}
                    >
                        {
                            (categoryData)?.map((item, i) => {
                                const isChecked = item.id === rowForm?.categoryId;
                                const disableCheckbox = (rowForm?.categoryId && !isChecked) || viewOnly;
                                return (
                                    <StyledTreeItem fontSize={'1rem'}
                                        showButton={!item.subCategories?.length}
                                        isSelected={isChecked}
                                        fontWeight={600}
                                        nodeId={`${item?.id}-c`}
                                        label={item.categoryDispVal}
                                        checkboxHandler={(e) => onCategoryCheckboxClick(e, item)}
                                        disableCheckbox={disableCheckbox}
                                        key={`${item?.id}-c`}
                                    >
                                        {(item.subCategories)?.map((sc, k) => {
                                            const isChecked = sc.id === rowForm?.subCategoryId;
                                            const disableCheckbox = (rowForm?.subCategoryId && !isChecked) || viewOnly;
                                            return (
                                                <StyledTreeItem fontSize={'0.875rem'}
                                                    showButton={!sc?.subSubCategory?.length}
                                                    isSelected={isChecked}
                                                    fontWeight={400}
                                                    nodeId={`${sc?.id}-sc`}
                                                    label={sc.subCategoryDispVal}
                                                    checkboxHandler={(e) => onSubCategoryCheckboxClick(e, item, sc)}
                                                    disableCheckbox={disableCheckbox}
                                                    key={`${sc?.id}-sc`}
                                                >
                                                    {(sc.subSubCategory)?.map((ssc, j) => {
                                                        const isChecked = ssc.id === rowForm?.subSubCategoryId;
                                                        const disableCheckbox = (rowForm?.subSubCategoryId && !isChecked) || viewOnly;
                                                        return (
                                                            <StyledTreeItem fontSize={'0.875rem'}
                                                                isSelected={isChecked}
                                                                showButton
                                                                fontWeight={400}
                                                                nodeId={`${ssc?.id}-ssc`}
                                                                label={ssc.subSubCategoryDisplayValue}
                                                                checkboxHandler={e => onSubSubCategoryCheckboxClick(e, item, sc, ssc)}
                                                                disableCheckbox={disableCheckbox}
                                                                key={`${ssc?.id}-ssc`}
                                                            />
                                                        )
                                                    })}
                                                </StyledTreeItem>
                                            )

                                        })}
                                    </StyledTreeItem>
                                )
                                // }
                            })
                        }
                    </TreeView>
                </div>
            </div>
        </Dialog>
    )
}

export default ConcessionCategoryDialog;